import { Col, Row } from 'reactstrap';
import 'utils/jsdocTypes';

/**
 * @typedef {Object} Props
 * @property {InvoiceRowData} invoiceRowData
 */

/**
 * @function InvoiceLineItem
 * @param {Props} props
 * @type {React.JSX.Element}
 */
const InvoiceLineItem = ({ invoiceRowData }) => {
  return (
    <Row className="invoiceLineItem">
      <Col sm="2">{invoiceRowData.quantity}</Col>
      <Col sm="6">{invoiceRowData.description}</Col>
      <Col sm="2">{invoiceRowData.unitPrice ? '$' + invoiceRowData.unitPrice : ''}</Col>
      <Col sm="2">{invoiceRowData.total ? '$' + invoiceRowData.total : ''}</Col>
    </Row>
  );
};

export default InvoiceLineItem;
